import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  enabled?: boolean;
}

const useSharedWithMe = ({ enabled = true }: IProps = {}) => {
  const query = useQuery({
    queryKey: ['collections', 'shared'],
    queryFn: async () => {
      const response = await Api.sharedWithMe();
      return response.data.data;
    },
    enabled,
  });

  return {
    collections: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useSharedWithMe;
